
import '../commom/Challenger';

export default function CutRetailDto(dto) {
    if (!dto) {
        return null;
    }
    
    let tempDto = JSON.Clone(dto);

    delete tempDto.Member;
    delete tempDto.Person;
    if (tempDto && tempDto.RetailDetails) {
        tempDto.RetailDetails.forEach(detail => {
            // 删除存货属性
            delete detail.Inventory;
            delete detail.PromotionDetails;
            delete detail.RetailDetailPaymentRelations;
            delete detail.Unit;
            delete detail.Unit2;
        });
    }
    return tempDto;
}